import { render, staticRenderFns } from "./MediaSettingsEditor.vue?vue&type=template&id=7e52570b&scoped=true&"
import script from "./MediaSettingsEditor.vue?vue&type=script&lang=js&"
export * from "./MediaSettingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediaSettingsEditor.vue?vue&type=style&index=0&id=7e52570b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e52570b",
  null
  
)

export default component.exports